import React, { useState } from "react";
import "./ListContent.css";
import { Button } from "primereact/button";

function ListContent({ content }) {
  // State to track whether content is visible or not
  const [isContentVisible, setIsContentVisible] = useState(false);

  // Ensure content is an array before sorting
  const sortedContent = Array.isArray(content)
    ? [...content].sort((a, b) => a.sortOrder - b.sortOrder)
    : [];
  const images = [
    "/images/websiteelements-05.svg",
    "/images/websiteelements-04.svg",
    "/images/websiteelements-07.svg",
    "/images/websiteelements-06.svg",
  ];
  const hoverImages = [
    "/images/websiteelements-11.svg",
    "/images/websiteelements-10.svg",
    "/images/websiteelements-14.svg",
    "/images/websiteelements-13.svg",
  ];
  const toggleContent = () => {
    setIsContentVisible(!isContentVisible); // Toggle the visibility state
  };

  return (
    <div className="ContentList-container">
      <Button
        label={isContentVisible ? "Show Less" : "Show More"}
        className="showButton"
        onClick={toggleContent} // Handle button click to toggle content
      />
      {sortedContent.map((item, index) => (
        <div
          key={index}
          className={`content-item ${
            index % 2 === 0 ? "left" : "right"
          } aboutitem-${index + 1}`}
        >
          {/* Conditionally swap the order of text and image */}
          {index % 2 === 0 ? (
            <div className="text-container">
              <h2 className={!isContentVisible ? "padding-bottom" : ""}>
                {item.title}
              </h2>
              <p
                className={`p-content-text ${
                  !isContentVisible ? "collapsed" : "expanded"
                }`}
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              />
            </div>
          ) : (
            <div
              className={`image-container ${
                !isContentVisible ? "" : ""
              } image-container-${index + 1}`}
            >
              <img
                className="defaultimage"
                src={images[index % images.length]}
                alt={`Image ${index}`}
              />
              <img
                src={hoverImages[index % hoverImages.length]}
                alt={`HoverImage ${index}`}
                className="HoverImage"
              />
            </div>
          )}

          {index % 2 === 0 ? (
            <div
              className={`image-container ${
                !isContentVisible ? "" : ""
              } image-container-${index + 1}`}
            >
              <img
                src={images[index % images.length]}
                className="defaultimage"
                alt={`Image ${index}`}
              />
              <img
                className="HoverImage"
                src={hoverImages[index % hoverImages.length]}
                alt={`HoverImage ${index}`}
              />
            </div>
          ) : (
            <div className="text-container">
              <h2 className={!isContentVisible ? "padding-bottom" : ""}>
                {item.title}
              </h2>
              <p
                className={`p-content-text ${
                  !isContentVisible ? "collapsed" : "expanded"
                }`}
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default ListContent;
